import { VideoWallBoardDesktop } from "./VideoWallBoardDesktop";
import { VideoWallBoardMobile } from "./VideoWallBoardMobile";

interface VideoWallBoardProps {
  isMobile: boolean;
  watchMouseMove?: boolean;
  onStopAnimating?: (v: boolean) => any;
}

export const VideoWallBoard: React.FC<VideoWallBoardProps> = ({
  isMobile,
  children,
  watchMouseMove = true,
  onStopAnimating,
}) => {
  if (isMobile) {
    return (
      <VideoWallBoardMobile onStopAnimating={onStopAnimating}>
        {children}
      </VideoWallBoardMobile>
    );
  }

  return (
    <VideoWallBoardDesktop
      onStopAnimating={onStopAnimating}
      watchMouseMove={watchMouseMove}
    >
      {children}
    </VideoWallBoardDesktop>
  );
};
